<template>
  <div v-if="product" class="product-page">
    <div class="flex content-container">
      <div class="images-container">
        <div class="main-image-container">
          <div
            class="main"
            :style="{
              backgroundImage: `url(${this.selectedImage})`
            }"
          >
            <img
              sizes="(max-width: 767px) calc(50vw - 36px), (min-width: 768px) and (max-width: 1280px) calc(25vw - 64px), 284px"
              :src="this.selectedImage"
            />
          </div>
        </div>
        <div class="previews">
          <div
            class="preview"
            v-for="(image, i) in images"
            :key="i"
            :style="{
              backgroundImage: `url(${getProductThumbnail(
                image,
                product.store
              )}), url(${image})`
            }"
            @click="setSelectedImage(image)"
            @mouseover="setSelectedImage(image)"
          ></div>
        </div>
      </div>
      <div class="product-page-images-previews--mobile breakout">
        <b-carousel v-model="slide" :interval="0" controls indicators>
          <b-carousel-slide
            v-for="(image, j) in images"
            img-width="200"
            img-height="200"
            :key="j"
            :img-src="image"
          />
        </b-carousel>
      </div>
      <div class="product-information">
        <h1>{{ product.name }}</h1>
        <h5 class="brand">
          {{ product.brand }}
        </h5>
        <div class="prices">
          <span class="price" :class="{ crossed: product.priceSale }">
            {{ product.priceOriginal | currency }}
          </span>
          <span v-if="product.priceSale" class="price sale">
            {{ product.priceSale | currency }}
          </span>
          <p
            v-if="product.sustainable"
            class="price sustainable"
            v-b-tooltip.hover
            :title="`product_page.tooltips.sustainable` | translate"
          ></p>
        </div>
        <div class="store">
          <span class="title">
            {{ "product_page.titles.store" | translate }}:
          </span>
          <div class="flex">
            <div class="logo">
              <img src="../assets/images/store_logos/marita_huurinainen.png" />
            </div>
            <div class="flex-col">
              <span class="store-name" @click="goToStorePage">
                {{ `store.${product.store}` | translate }}
              </span>
              <span class="address">Strees address here</span>
            </div>
          </div>
        </div>
        <template v-if="product.sizes.length">
          <v-select
            :options="product.sizes"
            v-model="product.chosenSize"
            :placeholder="'product_page.titles.choose_size' | translate"
            @input="sizeChosen"
            @search:blur="selectBlurred"
            class="sizes mb-small"
            ref="sizeSelect"
          ></v-select>
        </template>
        <div class="flex button-container">
          <button class="button salmon" @click="onAddToCartClicked">
            {{ "product_page.titles.add_to_cart" | translate }}
          </button>
          <wishlist-component
            :product="product"
            :isButton="true"
          ></wishlist-component>
        </div>
      </div>
    </div>
    <div class="additional-info content-container">
      <div class="titles">
        <div
          class="title"
          @click="onMoreInfoClick"
          :class="{ active: !shippingVisible }"
        >
          {{ "product_page.titles.more_product_info" | translate }}
        </div>
        <div
          class="title"
          @click="onShippingClick"
          :class="{ active: shippingVisible }"
        >
          {{ "product_page.titles.shipping_returns" | translate }}
        </div>
      </div>
      <div class="horizontal-line"></div>
      <div v-if="!shippingVisible" class="content">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod
          tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquid ex
          ea commodi consequat. Quis aute iure reprehenderit in voluptate velit
          esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat
          cupiditat non proident, sunt in culpa qui officia deserunt mollit anim
          id est laborum
        </p>
      </div>
      <div v-if="shippingVisible" class="content">
        <p>
          SHIPPING Lorem ipsum dolor sit amet, consectetur adipisci elit, sed
          eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquid ex ea commodi consequat. Quis aute iure reprehenderit in
          voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint obcaecat cupiditat non proident, sunt in culpa qui officia
          deserunt mollit anim id est laborum
        </p>
      </div>
    </div>
    <product-row
      :title_first="'product_page.titles.more_products' | translate"
      :title_second="'product_page.titles.in_zurich' | translate"
      see_more_link="Overview"
      :sex="this.product.sex"
      :filter="{
        sex: this.product.sex,
        category: this.product.category,
        type: this.product.type
      }"
    ></product-row>
    <product-row
      :title_first="'product_page.titles.same_brand' | translate"
      :title_second="'product_page.titles.in_zurich' | translate"
      see_more_link="Recommendations"
      :sex="this.product.sex"
      :filter="{ sex: this.product.sex, brand: [this.product.brand] }"
    ></product-row>
    <product-row
      :title_first="'product_page.titles.same_store' | translate"
      :title_second="'product_page.titles.in_zurich' | translate"
      see_more_link="Recommendations"
      :sex="this.product.sex"
      :filter="{ sex: this.product.sex, store: [this.product.store] }"
    ></product-row>
  </div>

  <div v-else class="empty-page">
    <gyra-spinner />
  </div>
</template>

<script>
import { getProductInfo } from "../services/api";
import { getSimilars } from "../services/api";
import GyraSpinner from "../components/atoms/gyra-spinner";
import { cartMethods, errorHandling } from "../mixins";
import { productImageResizer } from "../mixins";
import { mapGetters, mapMutations } from "vuex";
import ProductRow from "../components/molecules/product-row.vue";
import WishlistComponent from "../components/atoms/wishlist-component.vue";

export default {
  name: "ProductPage",
  components: { GyraSpinner, ProductRow, WishlistComponent },
  mixins: [errorHandling, productImageResizer, cartMethods],
  data() {
    return {
      product: null,
      selectedImage: null,
      addToCartWaitingSize: false,
      buyNowWaitingSize: false,
      similars: [],
      slide: 0,
      shippingVisible: false,
      error: null
    };
  },
  methods: {
    imageError() {
      this.error = true;
    },
    async getProduct() {
      const response = await getProductInfo(this.$route.params.id);
      if (response.status === 200) {
        this.product = response.data;
        this.selectedImage = this.product.imageSources[0];
      } else {
        this.handleHttpError(response);
      }
    },
    onMapIconClicked() {
      this.setProducts([this.product]);
      this.$router.push({ name: "ProductMap" });
    },
    goToStorePage() {
      this.$router.push({
        name: "StorePage",
        params: { store: this.product.store }
      });
    },
    onShippingClick() {
      this.shippingVisible = true;
    },
    onMoreInfoClick() {
      this.shippingVisible = false;
    },
    isSizeChosen() {
      if (this.product.chosenSize || this.product.sizes.length === 0) {
        return true;
      } else {
        this.$refs.sizeSelect.select();
        return false;
      }
    },
    onAddToCartClicked() {
      if (this.isSizeChosen()) {
        this.addProductToCart({ ...this.product });
        if (this.$cookies.get("accept-cookie-policy")) {
          this.$gtag.event("productAddedToCart", {
            event_category: "referals",
            event_label: "product",
            value: this.product._id
          });
        }
      } else {
        this.addToCartWaitingSize = true;
      }
    },
    onBuyClicked() {
      if (this.isSizeChosen()) {
        this.addProductToCart({ ...this.product });
        this.$router.push({ name: "CartPage" });
        if (this.$cookies.get("accept-cookie-policy")) {
          this.$gtag.event("productBuyClicked", {
            event_category: "referals",
            event_label: "product",
            value: this.product._id
          });
        }
      } else {
        this.buyNowWaitingSize = true;
      }
    },
    sizeChosen() {
      if (this.product.chosenSize) {
        if (this.addToCartWaitingSize) {
          this.onAddToCartClicked();
          this.addToCartWaitingSize = false;
        } else if (this.buyNowWaitingSize) {
          this.onBuyClicked();
          this.buyNowWaitingSize = false;
        }
      }
    },
    selectBlurred() {
      this.addToCartWaitingSize = false;
      this.buyNowWaitingSize = false;
    },
    async getSimilars() {
      const response = await getSimilars(this.$route.params.id, 4);
      if (response.status === 200) {
        this.similars = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    setSelectedImage(image) {
      this.selectedImage = image;
    },
    ...mapMutations({
      setProducts: "overview/setProducts"
    })
  },
  computed: {
    ...mapGetters({
      isProductInCart: "cart/isProductInCart"
    }),
    images() {
      return this.product ? this.product.imageSources.slice(0, 10) : null;
    }
  },
  beforeMount() {
    this.getProduct();
    this.getSimilars();
  },
  watch: {
    $route() {
      this.getProduct();
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
$margin-lg: 50px;
$margin-sm: 100px;
.product-page {
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    margin-top: $m-s;
  }

  .flex {
    @media (max-width: 600px) {
      flex-direction: column;
    }
  }
}

.images-container {
  display: none;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  padding-right: 3rem;
  @media (min-width: 600px) {
    display: flex;
  }

  .main-image-container {
    max-height: 40rem;
  }

  .main {
    width: 100%;
    height: auto;
    margin-bottom: 2rem;
    max-height: calc(24rem * 1.35);
    max-width: 24rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    width: 100%;

    img {
      visibility: hidden;
      width: 100%;
    }
  }

  .previews {
    display: flex;
    flex-direction: row;
    overflow: scroll;
    -ms-overflow-style: none;
    max-width: 25rem;
  }

  .preview {
    flex-shrink: 0;
    height: 7rem;
    width: 5rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    margin-right: 1rem;
  }
}

.product-page-images-previews::-webkit-scrollbar {
  display: none;
}

.product-page-images-previews--mobile {
  flex-shrink: 0;
  max-height: 700px;
  display: flex;
  margin-bottom: 2rem;
  @media (min-width: 600px) {
    display: none;
  }
  overflow: hidden;
}

.product-information {
  @media (min-width: 600px) {
    width: 50%;
  }

  h1 {
    font-size: $font-xl;
    margin-bottom: 1.5rem;
  }

  h5 {
    margin-bottom: 1.5rem;
    font-weight: 400;
  }
}

.remove-from-cart-button {
  p {
    background-color: $gyra-grey-light;
    color: $gyra-grey-lightest;
  }
}

.hidden {
  display: none !important;
}

.crossed {
  text-decoration: line-through;
}

.prices {
  display: flex;
  flex-direction: column;

  &::after {
    content: "";
    width: 100%;
    height: 2px;
    background-color: $brand-gray-light;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
}

.store {
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background-color: $brand-gray-light;
    margin: 1rem 0;
  }

  .title {
    font-weight: 700;
    margin-bottom: 1rem;
    display: flex;
  }

  .flex {
    align-items: center;
    flex-direction: row;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
    width: 4rem;
    border-radius: 50%;
    box-shadow: 0px 0px 15px rgb(0, 0, 0, 0.25);
    margin-right: 1rem;

    img {
      width: 3rem;
    }
  }

  .store-name {
    font-family: "Lora";
    margin-bottom: 0.5rem;
    cursor: pointer;
    transition: all 0.1s ease-in-out;

    &:hover {
      font-weight: 600;
    }
  }

  .address {
    font-size: $font-sm;
  }
}

.button-container {
  display: flex;
  justify-content: space-between;
  .wishlist-btn-container {
    width: 48%;
  }

  .salmon {
    width: 48%;
    font-size: $font-sm;
    font-weight: 500;
    padding-right: 1.5rem;
    box-shadow: none;
  }
}

.sale {
  color: $gyra-red;
  font-weight: 500;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.v-select.sizes {
  padding: 0;
  cursor: pointer;

  .vs__dropdown-toggle {
    border-radius: 0;
    padding: 0.5rem;
    position: relative;
    border-width: 2px;

    .vs__search {
      font-family: "Montserrat";
      text-align: center;
      font-weight: 500;
      color: $brand-gray-medium;
      font-size: $font-sm;
      margin: 0;
    }

    .vs__selected {
      padding: 0;
      margin: 0;
    }

    .vs__actions {
      position: absolute;
      right: 0.5rem;
      top: 0;
      padding: 0;
    }
  }
}
</style>
